module.exports = __webpack_public_path__ + "media/icons/audiobook-9170afad.svg";